import { getDaysUnit, TTemporalDialogSettings } from "@components/smart/FieldInfo";
import { createPath } from "@odata/BindingContext";
import {
    EntitySetName,
    EntityTypeName,
    PrPayrollSettingEntity,
    PrPayrollSettingTemporalCurrentEntity
} from "@odata/GeneratedEntityTypes";
import { getTemporalAdditionalProperties, getTemporalPropertyFieldDefinition } from "@odata/TemporalUtils";
import { setDefByEntityType } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import { IAppContext } from "contexts/appContext/AppContext.types";
import { FieldType } from "enums";
import i18next from "i18next";
import { DATE_MIN } from "types/Date";

import { IFormDef } from "../../../views/formView/Form";
import { TValue } from "../../../global.types";


export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {

    const commonTemporalDialogSetting: Partial<TTemporalDialogSettings> = {
        granularity: "month",
        withoutGaps: true,
        cannotBeEnded: true,
        newDefaultDateValidFrom: DATE_MIN
    };

    const form: IFormDef = {
        id: `${EntityTypeName.PrPayrollSetting}Form`,
        translationFiles: getDefinitions.translationFiles,
        fieldDefinition: {
            // we don't want new entity TemporalPropertyBag to be null => use default value
            [PrPayrollSettingEntity.TemporalPropertyBag]: {
                defaultValue: []
            },
            ...getTemporalPropertyFieldDefinition({
                propName: PrPayrollSettingTemporalCurrentEntity.SickDays,
                definition: {
                    type: FieldType.NumberInput,
                    defaultValue: 0,
                    useForValidation: true,
                    fieldSettings: {
                        unit: getDaysUnit,
                        formatter: (val: TValue): string => (val ?? 0).toString(),
                        temporalDialog: {
                            dialogTitle: i18next.t("Payroll:Setting.SickDaysTemporalDialog"),
                            columns: [PrPayrollSettingTemporalCurrentEntity.SickDays],
                            ...commonTemporalDialogSetting
                        }
                    }
                },
                currentDefinition: {
                    isRequired: false
                }
            }),
            ...getTemporalPropertyFieldDefinition({
                propName: PrPayrollSettingTemporalCurrentEntity.LeaveDays,
                definition: {
                    type: FieldType.NumberInput,
                    defaultValue: 20,
                    useForValidation: true,
                    fieldSettings: {
                        unit: getDaysUnit,
                        formatter: (val: TValue): string => (val ?? 0).toString(),
                        temporalDialog: {
                            dialogTitle: i18next.t("Payroll:Setting.LeaveDaysTemporalDialog"),
                            columns: [PrPayrollSettingTemporalCurrentEntity.LeaveDays],
                            ...commonTemporalDialogSetting
                        }
                    }
                },
                currentDefinition: {
                    isRequired: false
                }
            }),
        },
        groups: [
            {
                id: "defaultAbsences",
                title: i18next.t("Payroll:Setting.DefaultAbsences"),
                rows: [[
                    { id: createPath(PrPayrollSettingEntity.CurrentTemporalPropertyBag, PrPayrollSettingTemporalCurrentEntity.LeaveDays) },
                    { id: createPath(PrPayrollSettingEntity.CurrentTemporalPropertyBag, PrPayrollSettingTemporalCurrentEntity.SickDays) },
                ]]
            }
        ],
        additionalProperties: [
            ...getTemporalAdditionalProperties(PrPayrollSettingTemporalCurrentEntity, PrPayrollSettingEntity)
        ]
    };

    return {
        entitySet: EntitySetName.PrPayrollSettings,
        form
    };
};

getDefinitions.translationFiles = ["Payroll", "Common", "Error"/*, getEnumNameSpaceName(EntityTypeName.)*/];
setDefByEntityType(EntityTypeName.PrPayrollSetting, getDefinitions);